import SalesOrdersByTypeList from './SalesOrdersByTypeList'

export default {
  list: SalesOrdersByTypeList,
}
